import { render, staticRenderFns } from "./StartNav.vue?vue&type=template&id=18441a94&"
import script from "./StartNav.vue?vue&type=script&lang=ts&"
export * from "./StartNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports